export default __webpack_public_path__ + "static/media/search.94f247e7.svg";